import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

/**The intialization of the  translations library
 * @namespace i18n
 * @category Internationalization
 */

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: localStorage.lang ? localStorage.lang : "bg",
    backend: {
      /* translation file path */
      loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
    },
    fallbackLng: localStorage.lang ? localStorage.lang : "bg",
    debug: false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
